import { MoongateLogoColorBlack, MoongateLogoColorWhite } from "@assets";
import {
  Box,
  Link,
  Show,
  SimpleGrid,
  Stack,
  Text,
  VisuallyHidden,
  chakra,
  useColorModeValue,
} from "@chakra-ui/react";
import { MOONGATE_PRIVACY_URL, MOONGATE_TERMS_URL } from "@lib/misc";
import { ReactNode } from "react";
import { FaDiscord, FaInstagram, FaTwitter } from "react-icons/fa";
import { NextImage } from "../NextImage/NextImage";

const _t = (key?: string) => key || "";

const SocialButton = ({
  children,
  label,
  href,
}: {
  children: ReactNode;
  label: string;
  href: string;
}) => {
  return (
    <chakra.button
      w={8}
      h={8}
      cursor={"pointer"}
      as={"a"}
      href={href}
      display={"inline-flex"}
      alignItems={"center"}
      justifyContent={"center"}
      transition={"background 0.3s ease"}
      _hover={{
        bg: useColorModeValue("blackAlpha.200", "whiteAlpha.200"),
      }}
      color={"#9C7B64"}
    >
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};

const ListHeader = ({ children }: { children: ReactNode }) => {
  return (
    <Text fontWeight={"500"} fontSize={"1rem"} color={"#9C7B64"}>
      {children}
    </Text>
  );
};

const LinkWrap = ({
  children,
  href,
}: {
  children: ReactNode;
  href: string;
}) => {
  return (
    <Link
      fontWeight={500}
      color={"#9C7B64"}
      fontSize="md"
      href={href}
      display="flex"
      alignItems="center"
    >
      {children}
    </Link>
  );
};

const LandingFooter = () => {
  return (
    <div className="dark:bg-neutral-900 w-full border-t">
      <div className="container py-8 px-4 sm:px-0">
        <SimpleGrid
          templateColumns={{ base: "1fr", sm: "1fr 1fr" }}
          spacing={8}
        >
          <Stack spacing={2}>
            <Box>
              <a href="https://moongate.id" target="_blank" rel="noreferrer">
                <NextImage
                  className="w-32 sm:w-48 cursor-pointer"
                  src={useColorModeValue(
                    MoongateLogoColorBlack,
                    MoongateLogoColorWhite
                  )}
                  alt="moongate"
                />
              </a>
            </Box>
            <Stack direction={{ base: "column", sm: "row" }}>
              <div className="flex gap-2">
                <p className="text-xs dark:text-secondary ">
                  {_t("© 2023 Cedar Technology (International) Limited")}
                </p>
                <p className="text-xs dark:text-secondary ">|</p>
              </div>
              <p className="text-xs dark:text-secondary">
                {_t("7A, Max Share Centre, Hong Kong")}
              </p>
            </Stack>
          </Stack>
          <Stack align={{ base: "flex-start", sm: "flex-end" }} spacing={12}>
            <Stack
              direction={{ base: "column", md: "row" }}
              spacing={{ base: 0, md: 7 }}
              align={{ base: "flex-start", sm: "center" }}
            >
              <Stack direction={"row"} spacing={7} mb={{ base: 6, sm: 0 }}>
                <LinkWrap
                  href={
                    "https://themoongate.notion.site/Moongate-FAQs-ffbb9d4ba5084b8abf5a46829c923486"
                  }
                >
                  {_t("FAQ")}
                </LinkWrap>
                <LinkWrap href={MOONGATE_TERMS_URL}>{_t("Terms")}</LinkWrap>
                <LinkWrap href={MOONGATE_PRIVACY_URL}>{_t("Privacy")}</LinkWrap>
              </Stack>
              <Show above="sm">
                <ListHeader>{"|"}</ListHeader>
              </Show>
              <ListHeader>
                <span className="text-[#9C7B64] text-sm">
                  {_t("Contact us")}
                </span>
              </ListHeader>
              <Stack direction={"row"} spacing={2} py={2}>
                <SocialButton
                  label={_t("Twitter")}
                  href={"https://twitter.com/0xmoongate"}
                >
                  <FaTwitter />
                </SocialButton>
                <SocialButton
                  label={_t("Instagram")}
                  href={"https://www.instagram.com/0xmoongate/"}
                >
                  <FaInstagram />
                </SocialButton>
                <SocialButton
                  label={_t("Discord")}
                  href={"https://discord.com/invite/KpvCUD5NgM"}
                >
                  <FaDiscord />
                </SocialButton>
              </Stack>
            </Stack>
          </Stack>
        </SimpleGrid>
      </div>
    </div>
  );
};
export default LandingFooter;
